function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2051",
    style: {
      fill: "#cc0034",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.738116,236.78765 c 0,10.22703 -4.545896,18.5173 -10.153298,18.5173 -5.607757,0 -10.153298,-8.29027 -10.153298,-18.5173 0,-10.22632 4.545541,-18.5166 10.153298,-18.5166 5.607402,0 10.153298,8.29028 10.153298,18.5166"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2053",
    style: {
      fill: "#cc0034",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.244218,235.59844 c 7.23124,7.23123 9.87919,16.30785 5.913967,20.27308 -3.965224,3.96522 -13.041842,1.31727 -20.273081,-5.91397 -7.231238,-7.23124 -9.8795404,-16.30751 -5.913613,-20.27308 3.964869,-3.96522 13.041135,-1.31727 20.272727,5.91397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2055",
    style: {
      fill: "#cc0034",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.033043,247.12792 c 10.226675,0 18.516952,4.54519 18.516952,10.1533 0,5.60775 -8.290277,10.15329 -18.516952,10.15329 -10.2263206,0 -18.51695144,-4.54554 -18.51695144,-10.15329 0,-5.60741 8.29063084,-10.1533 18.51695144,-10.1533"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2057",
    style: {
      fill: "#cc0034",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 17.843477,264.62217 c 7.231591,-7.23159 16.308209,-9.87954 20.273433,-5.91397 3.965223,3.96523 1.317273,13.04149 -5.914319,20.27234 -7.23124,7.23124 -16.307859,9.87958 -20.273081,5.91439 -3.9648687,-3.96529 -1.317272,-13.04159 5.913967,-20.27276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2059",
    style: {
      fill: "#cc0034",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.37296,277.83264 c 7.93e-4,-10.22632 4.545893,-18.5166 10.15365,-18.5166 5.607401,0 10.153298,8.29028 10.152943,18.5166 0,10.22696 -4.545187,18.51723 -10.152943,18.51723 -5.607757,0 -10.15365,-8.29027 -10.15365,-18.51723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2061",
    style: {
      fill: "#cc0034",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.866858,279.02256 c -7.230888,-7.23195 -9.878484,-16.30786 -5.913615,-20.27308 3.965223,-3.96523 13.041487,-1.31728 20.273079,5.91396 7.231239,7.23124 9.879541,16.30754 5.913966,20.27312 -3.96522,3.96515 -13.042193,1.31727 -20.27343,-5.914"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2063",
    style: {
      fill: "#cc0034",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 60.078385,267.49307 c -10.226675,-7.9e-4 -18.516952,-4.54589 -18.517307,-10.15329 0,-5.60811 8.290632,-10.1533 18.517307,-10.1533 10.226675,0 18.517303,4.54519 18.517303,10.1533 -2.64e-4,5.6074 -8.290628,10.15329 -18.517303,10.15329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2065",
    style: {
      fill: "#cc0034",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 61.267597,249.99883 c -7.231592,7.23123 -16.307504,9.87918 -20.273079,5.91396 -3.964869,-3.96522 -1.317273,-13.04184 5.913967,-20.27308 7.231591,-7.23124 16.30821,-9.87919 20.273433,-5.91397 3.964868,3.96558 1.31727,13.04185 -5.914321,20.27309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2067",
    style: {
      fill: "#bd4765",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.575999,255.90503 c -0.207433,0 -0.412398,-0.0159 -0.615246,-0.0476 0.130175,-0.17603 0.24624,-0.363 0.34784,-0.55915 0.09208,0.005 0.183798,0.007 0.276225,0.007 0.07796,0 0.155575,-0.001 0.233185,-0.005 0.10019,0.19685 0.214842,0.38453 0.343958,0.56127 -0.19332,0.0289 -0.388408,0.0434 -0.585962,0.0434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2069",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.584818,255.30495 c -0.09243,0 -0.18415,-0.002 -0.276225,-0.007 0.09913,-0.19085 0.184502,-0.39053 0.256823,-0.59902 0.07091,0.20885 0.154869,0.40958 0.252587,0.60114 -0.07761,0.003 -0.15522,0.005 -0.233185,0.005 m -0.0032,-7.67291 c -0.859719,-3.46428 -3.019425,-7.3533 -6.25475,-10.90013 1.206148,-4.03401 3.552473,-6.77086 6.249106,-6.77086 2.703687,0 5.055304,2.75131 6.258629,6.80226 -3.227917,3.53589 -5.385858,7.41151 -6.252985,10.86873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2071",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.243683,249.4245 c -0.834322,-2.39995 -2.483557,-4.99851 -4.810125,-7.32508 -0.597959,-0.59795 -1.213557,-1.15076 -1.839384,-1.65699 0.140404,-1.31939 0.390877,-2.56681 0.732719,-3.71052 3.235325,3.54683 5.395031,7.43585 6.25475,10.90013 -0.153458,0.61171 -0.2667,1.21108 -0.33796,1.79246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2073",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.573883,250.53046 c -0.08996,-0.3623 -0.20038,-0.73201 -0.3302,-1.10596 0.07126,-0.58138 0.184502,-1.18075 0.33796,-1.79246 0.867127,-3.45722 3.025068,-7.33284 6.252985,-10.86873 0.339021,1.14018 0.586671,2.38336 0.725665,3.69746 -0.630767,0.50906 -1.251302,1.06574 -1.853494,1.66829 -2.679348,2.67899 -4.460171,5.71994 -5.132916,8.4014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2075",
    style: {
      fill: "#bd4765",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.107385,256.70443 c -0.03246,-0.21696 -0.08255,-0.43145 -0.149577,-0.64241 0.06844,-0.0617 0.135112,-0.12524 0.200377,-0.1905 0.05503,-0.055 0.109008,-0.11113 0.161218,-0.16828 0.210608,0.0684 0.424746,0.1203 0.64135,0.15416 -0.116417,0.15699 -0.24412,0.30551 -0.38382,0.44521 -0.146757,0.14676 -0.303742,0.28081 -0.469548,0.40182"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2077",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.957808,256.06202 c -0.06491,-0.20462 -0.14605,-0.40676 -0.242007,-0.60502 0.197909,0.0977 0.399344,0.17992 0.603602,0.24624 -0.05221,0.0572 -0.106185,0.11324 -0.161218,0.16828 -0.06527,0.0653 -0.13194,0.12876 -0.200377,0.1905 m -3.736975,-4.59105 c -3.065992,-2.40524 -7.984773,-4.04813 -13.620751,-4.30742 -1.999897,-3.70558 -2.276475,-7.29968 -0.369358,-9.20644 0.875241,-0.87524 2.106436,-1.29082 3.539419,-1.29082 2.579864,0 5.816952,1.34515 8.824031,3.77614 -0.08608,0.80609 -0.131233,1.63865 -0.131233,2.49061 0,3.26954 0.663575,6.25651 1.757892,8.53793"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2079",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.774341,252.50319 c -2.372783,-1.42945 -5.793317,-2.32656 -9.595909,-2.32656 -0.845608,0 -1.672167,0.0444 -2.472619,0.12911 -0.833262,-1.03223 -1.538817,-2.09197 -2.105731,-3.14219 5.635978,0.25929 10.554759,1.90218 13.620751,4.30742 0.173918,0.36265 0.358775,0.70732 0.553508,1.03222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2081",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.960753,255.8574 c -0.216604,-0.0339 -0.430742,-0.0857 -0.64135,-0.15416 0.137232,-0.14887 0.265996,-0.3048 0.38594,-0.46672 0.199318,0.031 0.401108,0.0519 0.60325,0.0617 -0.1016,0.19615 -0.217665,0.38312 -0.34784,0.55915"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2083",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.308593,255.29825 c -0.202142,-0.01 -0.403932,-0.0307 -0.60325,-0.0617 0.272343,-0.36689 0.50024,-0.76624 0.685093,-1.1938 0.04516,0.22683 0.103365,0.44591 0.17498,0.65652 -0.07232,0.20849 -0.157692,0.40816 -0.256823,0.59901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2085",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.319403,255.70324 c -0.204258,-0.0663 -0.405693,-0.14852 -0.603602,-0.24624 -0.309385,-0.63782 -0.775758,-1.24001 -1.375833,-1.79387 -0.543632,-0.78141 -1.25871,-1.51695 -2.119135,-2.19216 -1.094317,-2.28142 -1.757892,-5.26839 -1.757892,-8.53793 0,-0.85196 0.04515,-1.68452 0.131233,-2.49061 0.625827,0.50623 1.241425,1.05904 1.839384,1.65699 2.326568,2.32657 3.975803,4.92513 4.810125,7.32508 -0.13194,1.0728 -0.121709,2.08633 0.03775,3.01519 -0.02574,0.56551 0.0099,1.10314 0.109008,1.60303 -0.184853,0.42756 -0.41275,0.82691 -0.685093,1.1938 -0.119944,0.16192 -0.248708,0.31785 -0.38594,0.46672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2087",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.339968,253.66313 c -0.450498,-0.41593 -0.975432,-0.80434 -1.565627,-1.15994 -0.194733,-0.3249 -0.37959,-0.66957 -0.553508,-1.03222 0.860425,0.67521 1.575503,1.41075 2.119135,2.19216"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2089",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.281428,252.43969 c -0.159454,-0.92886 -0.169685,-1.94239 -0.03775,-3.01519 0.12982,0.37395 0.240241,0.74366 0.3302,1.10596 -0.166159,0.66181 -0.264584,1.30175 -0.292455,1.90923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2091",
    style: {
      fill: "#bd4765",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.102799,257.90563 c -0.176389,-0.13053 -0.362656,-0.24659 -0.559506,-0.34854 0.0046,-0.0917 0.0067,-0.18345 0.0067,-0.27587 0,-0.0776 -0.0013,-0.15523 -0.0046,-0.23284 0.197201,-0.10019 0.384881,-0.21484 0.561975,-0.34395 0.02858,0.19332 0.04304,0.3884 0.04304,0.58561 0,0.20743 -0.01588,0.41275 -0.04762,0.61559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2093",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 18.977304,263.53914 c -4.034013,-1.20615 -6.771569,-3.55247 -6.771569,-6.2491 0,-3.46499 4.518378,-6.35106 10.500078,-6.9843 0.509058,0.63077 1.065741,1.25095 1.668286,1.85314 2.312105,2.31246 4.893027,3.9557 7.280627,4.79496 -3.868915,0.46708 -8.509,2.78306 -12.677422,6.5853 m 18.565989,-5.98205 c -0.1905,-0.0984 -0.390525,-0.18415 -0.59831,-0.25612 0.208491,-0.0709 0.40922,-0.15487 0.600427,-0.25259 0.0032,0.0776 0.0046,0.15522 0.0046,0.23284 0,0.0924 -0.0021,0.18415 -0.0067,0.27587"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2095",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 22.688174,264.27186 c -1.319742,-0.14076 -2.567164,-0.39088 -3.71087,-0.73272 4.168422,-3.80224 8.808507,-6.11822 12.677422,-6.5853 0.378884,0.13335 0.753534,0.24624 1.120775,0.33866 -2.688518,0.66711 -5.741458,2.4511 -8.43033,5.13962 -0.597958,0.59796 -1.151114,1.21391 -1.656997,1.83974"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2097",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.54541,257.04838 c -0.0085,-0.20284 -0.02752,-0.40393 -0.05715,-0.6036 0.162631,-0.11889 0.319616,-0.24659 0.469548,-0.38276 0.06703,0.21096 0.11712,0.42545 0.149577,0.64241 -0.177094,0.12911 -0.364774,0.24376 -0.561975,0.34395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2099",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.48826,256.44478 c -0.06738,-0.45155 -0.188384,-0.895 -0.359834,-1.32821 0.192265,0.12841 0.388057,0.24201 0.587375,0.34043 0.09596,0.19826 0.177094,0.4004 0.242007,0.60502 -0.149932,0.13617 -0.306917,0.26387 -0.469548,0.38276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2101",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.944983,257.30097 c -0.585613,-0.2032 -1.236488,-0.30198 -1.936398,-0.30198 -0.101249,0 -0.2032,0.002 -0.306565,0.006 -0.520346,-0.0935 -1.067504,-0.13934 -1.637242,-0.13934 -0.456142,0 -0.927452,0.0296 -1.410052,0.0878 -2.3876,-0.83926 -4.968522,-2.4825 -7.280627,-4.79496 -0.602545,-0.60219 -1.159228,-1.22237 -1.668286,-1.85314 0.800452,-0.0847 1.627011,-0.12911 2.472619,-0.12911 3.802592,0 7.223126,0.89711 9.595909,2.32656 0.677333,1.13101 1.474962,2.02601 2.354085,2.61338 0.17145,0.43321 0.292452,0.87666 0.359834,1.32821 0.02963,0.19967 0.04868,0.40076 0.05715,0.6036 -0.191207,0.0977 -0.391936,0.18168 -0.600427,0.25259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2103",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.775501,257.2925 c -0.367241,-0.0924 -0.741891,-0.20531 -1.120775,-0.33866 0.4826,-0.0582 0.95391,-0.0878 1.410052,-0.0878 0.569738,0 1.116896,0.0459 1.637242,0.13934 -0.612069,0.0243 -1.258359,0.12136 -1.926519,0.28716"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2105",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.715801,255.457 c -0.199318,-0.0984 -0.39511,-0.21202 -0.587375,-0.34043 -0.197556,-0.49918 -0.46214,-0.9846 -0.788458,-1.45344 0.600075,0.55386 1.066448,1.15605 1.375833,1.79387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2107",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.128426,255.11657 c -0.879123,-0.58737 -1.676752,-1.48237 -2.354085,-2.61338 0.590195,0.3556 1.115129,0.74401 1.565627,1.15994 0.326318,0.46884 0.590902,0.95426 0.788458,1.45344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2109",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.740863,277.92538 c -1.433689,0 -2.663825,-0.41522 -3.538714,-1.29039 -2.450395,-2.44976 -1.296811,-7.6853 2.486025,-12.36313 0.805744,0.0861 1.6383,0.13088 2.490258,0.13088 3.269544,0 6.256867,-0.66322 8.538279,-1.75789 -2.405591,3.06634 -4.048828,7.98435 -4.30812,13.6211 -2.004838,1.0819 -3.97757,1.65943 -5.667728,1.65943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2111",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.408591,276.26595 c 0.259292,-5.63675 1.902529,-10.55476 4.30812,-13.6211 0.362305,-0.17392 0.706967,-0.35842 1.03223,-0.55316 -1.429456,2.37243 -2.326571,5.79297 -2.326923,9.59626 0,0.84529 0.04445,1.67185 0.129117,2.47192 -1.032227,0.83333 -2.091974,1.53913 -3.142544,2.10608"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2113",
    style: {
      fill: "#bd4765",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.30741,258.90823 c -0.06174,-0.0681 -0.125236,-0.13476 -0.1905,-0.20003 -0.05503,-0.055 -0.111125,-0.10901 -0.168275,-0.16157 0.06844,-0.21026 0.120298,-0.42474 0.154164,-0.641 0.156986,0.11607 0.305504,0.24412 0.444852,0.38347 0.147109,0.14676 0.28081,0.30374 0.402167,0.4699 -0.21731,0.0321 -0.431448,0.0822 -0.642408,0.14923"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2115",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.702395,259.15023 c 0.09737,-0.19791 0.179916,-0.39899 0.24624,-0.6036 0.05715,0.0526 0.113241,0.10654 0.168275,0.16157 0.06526,0.0653 0.128764,0.13194 0.1905,0.20003 -0.204965,0.0649 -0.4064,0.14605 -0.605015,0.242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2117",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.948635,258.54663 c -0.149225,-0.13758 -0.3048,-0.26599 -0.467077,-0.38629 0.03104,-0.19897 0.05186,-0.40076 0.06174,-0.60325 0.19685,0.10195 0.383117,0.21801 0.559506,0.34854 -0.03387,0.21626 -0.08573,0.43074 -0.154164,0.641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2119",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.481558,258.16034 c -0.366538,-0.27164 -0.765882,-0.49954 -1.193097,-0.68439 0.226838,-0.0452 0.445559,-0.10336 0.656522,-0.17498 0.207785,0.072 0.40781,0.15769 0.59831,0.25612 -0.0099,0.20249 -0.03069,0.40428 -0.06174,0.60325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2121",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 25.178432,264.40274 c -0.851958,0 -1.684514,-0.0448 -2.490258,-0.13088 0.505883,-0.62583 1.059039,-1.24178 1.656997,-1.83974 2.688872,-2.68852 5.741812,-4.47251 8.43033,-5.13962 0.791634,0.19862 1.551869,0.30057 2.262365,0.30057 0.437092,0 0.855485,-0.0388 1.250595,-0.11712 0.427215,0.18485 0.826559,0.41275 1.193097,0.68439 0.162277,0.1203 0.317852,0.24871 0.467077,0.38629 -0.06632,0.20461 -0.148874,0.40569 -0.24624,0.6036 -0.637469,0.30939 -1.23966,0.77576 -1.793521,1.37548 -0.781756,0.54399 -1.516946,1.25836 -2.192163,2.11914 -2.281412,1.09467 -5.268735,1.75789 -8.538279,1.75789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2123",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.716711,262.64485 c 0.675217,-0.86078 1.410407,-1.57515 2.192163,-2.11914 -0.415925,0.4505 -0.804333,0.97579 -1.159933,1.56598 -0.325263,0.19474 -0.669925,0.37924 -1.03223,0.55316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2125",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.288461,257.47595 c -0.493183,-0.21378 -1.02376,-0.36971 -1.586441,-0.47061 0.103365,-0.004 0.205316,-0.006 0.306565,-0.006 0.69991,0 1.350785,0.0988 1.936398,0.30198 -0.210963,0.0716 -0.429684,0.12982 -0.656522,0.17498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2127",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.037866,257.59307 c -0.710496,0 -1.470731,-0.10195 -2.262365,-0.30057 0.66816,-0.1658 1.31445,-0.26281 1.926519,-0.28716 0.562681,0.1009 1.093258,0.25683 1.586441,0.47061 -0.39511,0.0783 -0.813503,0.11712 -1.250595,0.11712"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2129",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.535076,284.65998 c -3.464983,0 -6.351058,-4.51774 -6.983941,-10.50011 0.630766,-0.50903 1.25095,-1.06574 1.853141,-1.66797 2.312107,-2.31179 3.955698,-4.89335 4.794957,-7.28059 0.467077,3.86927 2.78271,8.50857 6.585302,12.67781 -1.206149,4.03366 -3.552474,6.77086 -6.249459,6.77086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2131",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.784535,277.88912 c -3.802592,-4.16924 -6.118225,-8.80854 -6.585302,-12.67781 0.13335,-0.37924 0.246237,-0.75354 0.338666,-1.12113 0.66675,2.68852 2.4511,5.74185 5.139619,8.43068 0.59831,0.59793 1.213908,1.15105 1.839735,1.65735 -0.140758,1.31932 -0.390877,2.56717 -0.732718,3.71091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2133",
    style: {
      fill: "#bd4765",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.802835,259.32274 c -0.09172,-0.005 -0.183799,-0.007 -0.276225,-0.007 -0.07761,0 -0.155575,10e-4 -0.232834,0.005 -0.100541,-0.19721 -0.215193,-0.38489 -0.343958,-0.56163 0.192968,-0.0286 0.388056,-0.0434 0.585258,-0.0434 0.207434,0 0.413102,0.0162 0.61595,0.048 -0.130527,0.17603 -0.246591,0.36301 -0.348191,0.55915"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2135",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.546366,259.92176 c -0.07091,-0.20885 -0.155223,-0.40958 -0.25259,-0.60113 0.07726,-0.003 0.155223,-0.005 0.232834,-0.005 0.09243,0 0.184501,0.002 0.276225,0.007 -0.09878,0.19085 -0.18415,0.39053 -0.256469,0.59902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2137",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.68982,259.37777 c -0.118885,-0.16298 -0.246237,-0.31961 -0.38241,-0.46954 0.21096,-0.067 0.425098,-0.11713 0.642408,-0.14923 0.128765,0.17674 0.243417,0.36442 0.343958,0.56163 -0.202848,0.008 -0.404283,0.0275 -0.603956,0.0571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2139",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.362318,259.73761 c 0.12841,-0.19227 0.241652,-0.38771 0.340077,-0.58738 0.198615,-0.096 0.40005,-0.17709 0.605015,-0.242 0.136173,0.14993 0.263525,0.30656 0.38241,0.46954 -0.451554,0.0674 -0.894644,0.18839 -1.327502,0.35984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2141",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.551135,274.15987 c -0.08467,-0.80007 -0.129117,-1.62663 -0.129117,-2.47192 2.64e-4,-3.80329 0.897467,-7.22383 2.326923,-9.59626 1.131004,-0.67733 2.02565,-1.47531 2.613377,-2.35408 0.432858,-0.17145 0.875948,-0.29246 1.327502,-0.35984 0.199673,-0.0296 0.401108,-0.0487 0.603956,-0.0571 0.09737,0.19155 0.181682,0.39228 0.25259,0.60113 -0.23213,0.66957 -0.328083,1.42557 -0.29563,2.24155 -0.168275,0.93698 -0.182737,1.9625 -0.0515,3.048 -0.839259,2.38724 -2.48285,4.9688 -4.794957,7.28059 -0.602191,0.60223 -1.222375,1.15894 -1.853141,1.66797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2143",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.199233,265.21131 c -0.131234,-1.0855 -0.116772,-2.11102 0.0515,-3.048 0.02434,0.61242 0.121005,1.258 0.287163,1.92687 -0.09243,0.36759 -0.205316,0.74189 -0.338666,1.12113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2145",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.908874,260.52571 c 0.553861,-0.59972 1.156052,-1.06609 1.793521,-1.37548 -0.09842,0.19967 -0.211667,0.39511 -0.340077,0.58738 -0.499182,0.19755 -0.984957,0.46214 -1.453444,0.7881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2147",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.748941,262.09169 c 0.3556,-0.59019 0.744008,-1.11548 1.159933,-1.56598 0.468487,-0.32596 0.954262,-0.59055 1.453444,-0.7881 -0.587727,0.87877 -1.482373,1.67675 -2.613377,2.35408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2149",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 55.341285,277.95473 c -2.579865,0 -5.817307,-1.34524 -8.824032,-3.77652 0.08608,-0.80616 0.130882,-1.63862 0.130882,-2.49026 2.64e-4,-3.27025 -0.662869,-6.25721 -1.757892,-8.53863 3.066698,2.40524 7.984773,4.04883 13.621102,4.30777 1.999898,3.70558 2.276475,7.30031 0.369358,9.20683 -0.875242,0.87521 -2.106083,1.29081 -3.539418,1.29081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2151",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.511345,267.45709 c -5.636329,-0.25894 -10.554404,-1.90253 -13.621102,-4.30777 -0.173567,-0.3623 -0.358423,-0.70732 -0.553157,-1.03223 2.372784,1.42946 5.793672,2.32693 9.596261,2.32728 0.845608,0 1.671814,-0.0445 2.472621,-0.12912 0.833612,1.03258 1.538462,2.09127 2.105377,3.14184"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2153",
    style: {
      fill: "#bd4765",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 40.792024,258.9174 c -0.210608,-0.0684 -0.424391,-0.11995 -0.640998,-0.15381 0.116417,-0.15699 0.244123,-0.30586 0.383823,-0.44556 0.146754,-0.1464 0.303387,-0.28011 0.469194,-0.40111 0.03246,0.21661 0.08255,0.4311 0.149225,0.64171 -0.06809,0.0617 -0.13476,0.12558 -0.200025,0.19085 -0.05503,0.055 -0.109008,0.11112 -0.161219,0.16792"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2155",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.395626,259.16399 c -0.19826,-0.0977 -0.398991,-0.17991 -0.603602,-0.24659 0.05221,-0.0568 0.106186,-0.11289 0.161219,-0.16792 0.06527,-0.0653 0.13194,-0.12912 0.200025,-0.19085 0.06526,0.20496 0.14605,0.40675 0.242358,0.60536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2157",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 40.405733,259.38448 c -0.199322,-0.0314 -0.40005,-0.0519 -0.602898,-0.0617 0.1016,-0.19614 0.217664,-0.38312 0.348191,-0.55915 0.216607,0.0339 0.43039,0.0854 0.640998,0.15381 -0.137583,0.14922 -0.265996,0.3048 -0.386291,0.46708"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2159",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.720991,260.57793 c -0.04516,-0.22684 -0.103013,-0.44556 -0.174625,-0.65617 0.07232,-0.20849 0.157692,-0.40817 0.256469,-0.59902 0.202848,0.01 0.403576,0.0303 0.602898,0.0617 -0.271992,0.36689 -0.499534,0.76588 -0.684742,1.19345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2161",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.517253,274.17821 c -0.625827,-0.5063 -1.241425,-1.05942 -1.839735,-1.65735 -2.688519,-2.68883 -4.472869,-5.74216 -5.139619,-8.43068 0.320675,-1.27882 0.389112,-2.47509 0.183092,-3.51225 0.185208,-0.42757 0.41275,-0.82656 0.684742,-1.19345 0.120295,-0.16228 0.248708,-0.31786 0.386291,-0.46708 0.204611,0.0667 0.405342,0.14887 0.603602,0.24659 0.309385,0.63747 0.77611,1.24001 1.376185,1.79388 0.543632,0.7814 1.258007,1.51623 2.118432,2.19145 1.095023,2.28142 1.758243,5.26838 1.757892,8.53863 0,0.85164 -0.0448,1.6841 -0.130882,2.49026"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2163",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.890243,263.14932 c -0.860425,-0.67522 -1.5748,-1.41005 -2.118432,-2.19145 0.450147,0.41592 0.97508,0.80398 1.565275,1.15922 0.194734,0.32491 0.37959,0.66993 0.553157,1.03223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2165",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.250736,262.16331 c -0.03245,-0.81598 0.0635,-1.57198 0.29563,-2.24155 0.07161,0.21061 0.129469,0.42933 0.174625,0.65617 -0.213431,0.49282 -0.369358,1.02305 -0.470255,1.58538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2167",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.537899,264.09018 c -0.166158,-0.66887 -0.262821,-1.31445 -0.287163,-1.92687 0.100897,-0.56233 0.256824,-1.09256 0.470255,-1.58538 0.20602,1.03716 0.137583,2.23343 -0.183092,3.51225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2169",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.405968,264.31525 c -0.509413,-0.63076 -1.066448,-1.25165 -1.66864,-1.85385 -2.312104,-2.3121 -4.893379,-3.95499 -7.280627,-4.79425 3.868915,-0.46742 8.509,-2.78341 12.677421,-6.58565 4.034366,1.20615 6.771571,3.55212 6.771571,6.24946 -2.65e-4,3.46498 -4.51838,6.35106 -10.499725,6.98429"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2171",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.456701,257.66715 c -0.379235,-0.13335 -0.753181,-0.24659 -1.120775,-0.33866 2.688167,-0.6671 5.741459,-2.4511 8.430329,-5.13997 0.597958,-0.59796 1.151115,-1.21356 1.656998,-1.83974 1.31939,0.14076 2.567517,0.39123 3.710869,0.73272 -4.168421,3.80224 -8.808506,6.11823 -12.677421,6.58565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2173",
    style: {
      fill: "#bd4765",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.004043,257.91692 c -0.02857,-0.19332 -0.04339,-0.38876 -0.04339,-0.58596 0,-0.20744 0.01622,-0.41275 0.04798,-0.61595 0.176038,0.13053 0.363008,0.24694 0.559507,0.34854 -0.0046,0.0917 -0.0071,0.1838 -0.0071,0.27623 2.65e-4,0.0776 0.0019,0.15557 0.0049,0.23283 -0.197202,0.10019 -0.384882,0.21484 -0.561975,0.34431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2175",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.566018,257.57261 c -0.0032,-0.0773 -0.0046,-0.15522 -0.0049,-0.23283 0,-0.0924 0.0024,-0.1845 0.0071,-0.27623 0.190851,0.0988 0.390173,0.18415 0.598664,0.25647 -0.208846,0.0709 -0.409575,0.15522 -0.600781,0.25259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2177",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.153268,258.55863 c -0.06668,-0.21061 -0.116769,-0.4251 -0.149225,-0.64171 0.177093,-0.12947 0.364773,-0.24412 0.561975,-0.34431 0.0085,0.20285 0.02752,0.40393 0.05715,0.6036 -0.162983,0.11889 -0.319617,0.24624 -0.4699,0.38242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2179",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.983001,259.50407 c -0.19191,-0.12806 -0.388056,-0.24201 -0.587375,-0.34008 -0.09631,-0.19861 -0.177093,-0.4004 -0.242358,-0.60536 0.150283,-0.13618 0.306917,-0.26353 0.4699,-0.38242 0.06738,0.45156 0.188383,0.895 0.359833,1.32786"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2181",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.933347,264.44437 c -3.802589,-2.7e-4 -7.223477,-0.89782 -9.596261,-2.32728 -0.677333,-1.13065 -1.474962,-2.02529 -2.354085,-2.61302 -0.17145,-0.43286 -0.292452,-0.8763 -0.359833,-1.32786 -0.02963,-0.19967 -0.04868,-0.40075 -0.05715,-0.6036 0.191206,-0.0974 0.391935,-0.18168 0.600781,-0.25259 0.585259,0.20285 1.236486,0.30198 1.936044,0.30198 0.101248,0 0.2032,-0.002 0.306565,-0.006 0.520345,0.0931 1.067503,0.13935 1.637241,0.13935 0.456142,0 0.927452,-0.0296 1.410052,-0.0879 2.387248,0.83926 4.968523,2.48215 7.280627,4.79425 0.602192,0.6022 1.159227,1.22309 1.66864,1.85385 -0.800807,0.0847 -1.627013,0.12912 -2.472621,0.12912"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2183",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.046649,257.755 c -0.569738,0 -1.116896,-0.0462 -1.637241,-0.13935 0.612068,-0.0247 1.258358,-0.12136 1.926518,-0.28716 0.367594,0.0921 0.74154,0.20531 1.120775,0.33866 -0.4826,0.0582 -0.95391,0.0879 -1.410052,0.0879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2185",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.771811,260.95787 c -0.600075,-0.55387 -1.0668,-1.15641 -1.376185,-1.79388 0.199319,0.0981 0.395465,0.21202 0.587375,0.34008 0.197909,0.49953 0.462492,0.98495 0.78881,1.4538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2187",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.337086,262.11709 c -0.590195,-0.35524 -1.115128,-0.7433 -1.565275,-1.15922 -0.326318,-0.46884 -0.590901,-0.95427 -0.78881,-1.4538 0.879123,0.58773 1.676752,1.48237 2.354085,2.61302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2189",
    style: {
      fill: "#bd4765",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.008628,256.71501 c -0.156985,-0.11607 -0.305152,-0.24377 -0.444852,-0.38347 -0.146756,-0.14676 -0.28081,-0.30374 -0.401815,-0.4699 0.216607,-0.0321 0.431097,-0.0822 0.642057,-0.14887 0.06173,0.0681 0.125235,0.13476 0.1905,0.20002 0.05503,0.055 0.111125,0.10901 0.167923,0.16122 -0.06844,0.21096 -0.119946,0.42439 -0.153813,0.641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2191",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.162441,256.07401 c -0.0568,-0.0522 -0.11289,-0.10618 -0.167923,-0.16122 -0.06527,-0.0653 -0.128765,-0.13194 -0.1905,-0.20002 0.20461,-0.0653 0.4064,-0.14605 0.605015,-0.24236 -0.09772,0.19791 -0.179917,0.39934 -0.246592,0.6036 m 3.200045,-3.54471 c 1.429457,-2.37278 2.326924,-5.79332 2.326924,-9.59626 0,-0.84561 -0.04445,-1.67182 -0.129117,-2.47227 3.002843,-2.42429 6.23429,-3.76555 8.809918,-3.76555 1.43369,0 2.664177,0.41522 3.539419,1.29082 2.44969,2.44933 1.295755,7.68526 -2.486377,12.36274 -0.805743,-0.0857 -1.6383,-0.13088 -2.489906,-0.13088 -3.789186,0 -7.199136,0.89112 -9.570861,2.3114"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2193",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 40.161961,255.86164 c -0.129116,-0.17674 -0.243768,-0.36442 -0.343958,-0.56127 0.202496,-0.008 0.403932,-0.0275 0.603605,-0.0572 0.118885,0.16263 0.246237,0.31926 0.38241,0.46955 -0.21096,0.0667 -0.42545,0.11677 -0.642057,0.14887"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2195",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.818003,255.30037 c -0.09772,-0.19156 -0.181679,-0.39229 -0.252587,-0.60113 0.07302,-0.21061 0.132644,-0.43004 0.178858,-0.65688 0.182386,0.42969 0.407811,0.8315 0.677334,1.20086 -0.199673,0.0296 -0.401109,0.0487 -0.603605,0.0572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2197",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 40.804018,255.71277 c -0.136173,-0.15029 -0.263525,-0.30692 -0.38241,-0.46955 -0.269523,-0.36936 -0.494948,-0.77117 -0.677334,-1.20086 0.211312,-1.03575 0.147109,-2.23273 -0.170391,-3.5119 0.672745,-2.68146 2.453568,-5.72241 5.132916,-8.4014 0.602192,-0.60255 1.222727,-1.15923 1.853494,-1.66829 0.08467,0.80045 0.129117,1.62666 0.129117,2.47227 0,3.80294 -0.897467,7.22348 -2.326924,9.59626 -1.37795,0.82515 -2.405237,1.82915 -2.953453,2.94111 -0.198615,0.0963 -0.400405,0.17709 -0.605015,0.24236"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2199",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.565416,254.69924 c -0.07162,-0.21061 -0.129823,-0.42969 -0.17498,-0.65652 0.06491,-0.14993 0.124532,-0.30304 0.178859,-0.45967 0.05327,0.15628 0.111479,0.30938 0.174979,0.45931 -0.04621,0.22684 -0.105833,0.44627 -0.178858,0.65688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2201",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.390436,254.04272 c -0.09913,-0.49989 -0.13476,-1.03752 -0.109008,-1.60303 0.06844,0.39723 0.164042,0.77894 0.287867,1.14336 -0.05433,0.15663 -0.113946,0.30974 -0.178859,0.45967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2203",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.744274,254.04236 c -0.0635,-0.14993 -0.121708,-0.30303 -0.174979,-0.45931 -0.123825,-0.36442 -0.219427,-0.74613 -0.287867,-1.14336 0.02787,-0.60748 0.126296,-1.24742 0.292455,-1.90923 0.3175,1.27917 0.381703,2.47615 0.170391,3.5119"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2205",
    style: {
      fill: "#891c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.568135,257.06355 c -0.196499,-0.1016 -0.383469,-0.21801 -0.559507,-0.34854 0.03387,-0.21661 0.08537,-0.43004 0.153813,-0.641 0.149577,0.13758 0.305152,0.26599 0.467429,0.38629 -0.0314,0.19967 -0.05186,0.4004 -0.06173,0.60325"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2207",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.166799,257.32002 c -0.208491,-0.0723 -0.407813,-0.15769 -0.598664,-0.25647 0.0099,-0.20285 0.03034,-0.40358 0.06173,-0.60325 0.366538,0.27199 0.765881,0.49989 1.193096,0.68474 -0.226838,0.0452 -0.445558,0.10337 -0.656167,0.17498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2209",
    style: {
      fill: "#63131a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.335926,257.32849 c -0.791633,-0.19862 -1.551868,-0.30057 -2.26201,-0.30057 -0.437446,0 -0.85584,0.0388 -1.25095,0.11712 -0.427215,-0.18485 -0.826558,-0.41275 -1.193096,-0.68474 -0.162277,-0.1203 -0.317852,-0.24871 -0.467429,-0.38629 0.06668,-0.20426 0.14887,-0.40569 0.246592,-0.6036 1.115835,-0.54116 2.124075,-1.56492 2.953453,-2.94111 2.371725,-1.42028 5.781675,-2.3114 9.570861,-2.3114 0.851606,0 1.684163,0.0451 2.489906,0.13088 -0.505883,0.62618 -1.05904,1.24178 -1.656998,1.83974 -2.68887,2.68887 -5.742162,4.47287 -8.430329,5.13997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2211",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.409033,255.47041 c 0.548216,-1.11196 1.575503,-2.11596 2.953453,-2.94111 -0.829378,1.37619 -1.837618,2.39995 -2.953453,2.94111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2213",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.102843,257.622 c -0.699558,0 -1.350785,-0.0991 -1.936044,-0.30198 0.210609,-0.0716 0.429329,-0.12982 0.656167,-0.17498 0.493535,0.21344 1.02376,0.36971 1.586442,0.47061 -0.103365,0.004 -0.205317,0.006 -0.306565,0.006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2215",
    style: {
      fill: "#421417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.409408,257.61565 c -0.562682,-0.1009 -1.092907,-0.25717 -1.586442,-0.47061 0.39511,-0.0783 0.813504,-0.11712 1.25095,-0.11712 0.710142,0 1.470377,0.10196 2.26201,0.30057 -0.66816,0.1658 -1.31445,0.26246 -1.926518,0.28716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower14);
export default __webpack_public_path__ + "static/media/flower-14.d730c709025e4df43d207ff827d4fe28.svg";
export { ForwardRef as ReactComponent };